import { grey } from "@mui/material/colors";

import { pageStyles } from "components/Styled/Page/styles";
import { tableStyles } from "components/Styled/Table/sharedStyles";
import { TemplateContentType } from "features/Influencer/ContactList/schema";

const styles = {
  ...pageStyles,
  ...tableStyles,
  button: {
    fontSize: 14,
    color: grey[600],
    "&:hover": {
      color: "black",
    },
  },
  contentTypeChip: (contentType: TemplateContentType) => ({
    backgroundColor:
      contentType === TemplateContentType.OUTREACH ? "#dbeafd" : "#f2e6fe",
    color: contentType === TemplateContentType.OUTREACH ? "#5477d0" : "#9549c7",
    fontSize: 12,
    px: 1,
  }),
  nichesChip: {
    fontSize: 14,
    fontWeight: 500,
  },
  moreChip: {
    opacity: 0.5,
    pl: 3,
    backgroundColor: grey[200],
    color: "black",
    ml: -4,
    zIndex: 1,
  },
  root: {
    pb: "60px",
  },
  banner: {
    backgroundColor: "secondary.light",
    px: 2,
    py: 1,
    borderRadius: 4,
  },
  card: {
    borderRadius: 2,
    border: `1px solid ${grey[200]}`,
    boxShadow: "none",
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    "&:last-child": {
      pb: 2,
    },
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  menuButton: {
    fontSize: 14,
    color: grey[500],
    "&:hover": {
      color: "black",
    },
  },
  templateName: {
    fontSize: 16,
    fontWeight: 600,
    color: "black",
  },
  lastModified: {
    fontSize: 11,
    color: grey[600],
  },
  statsRow: {
    mt: 1,
    display: "flex",
    gap: 2,
  },
  stat: {
    flex: 1,
  },
  statValue: {
    fontSize: 15,
    fontWeight: 600,
    color: "black",
    lineHeight: 1.2,
  },
  statLabel: {
    fontSize: 12,
    color: grey[500],
  },
  statUpgrade: {
    fontSize: 14,
    fontWeight: 600,
    textDecoration: "none",
    cursor: "pointer",
    color: "purple.main",
  },
  controlsRow: {
    mt: 2,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 0.75,
  },
  controlsDivider: {
    width: "1px",
    height: 24,
    mx: 0.5,
    backgroundColor: grey[300],
    display: { xs: "none", md: "block" },
  },
  folderRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 0.75,
  },
  folderChip: (active: boolean) => ({
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 2,
    py: 0.75,
    borderRadius: 30,
    cursor: "pointer",
    border: "1px solid",
    borderColor: active ? "primary.main" : "transparent",
    backgroundColor: active ? "primary.main" : "#f7f7f5",
    color: active ? "common.white" : "text.primary",
    fontWeight: active ? 600 : 500,
    boxShadow: active ? "0 1px 6px rgba(0,0,0,0.18)" : "none",
    "&:hover": {
      backgroundColor: active ? "primary.dark" : "#e8e8e4",
    },
  }),
  folderChipLabel: {
    fontSize: 14,
    fontWeight: "inherit",
    color: "inherit",
  },
  folderChipCount: {
    fontSize: 12,
    color: "inherit",
    opacity: 0.65,
  },
  newFolderChip: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    px: 2,
    py: 0.75,
    borderRadius: 30,
    cursor: "pointer",
    border: "1px dashed",
    borderColor: grey[400],
    color: grey[700],
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "inherit",
    lineHeight: 1.5,
    backgroundColor: "transparent",
    "&:hover": {
      borderColor: "black",
      color: "black",
    },
  },
};

export default styles;
